// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListExternalAccountTypesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListExternalAccountTypesQuery = { __typename?: 'Query' } & {
  listExternalAccountTypes: Array<
    { __typename?: 'ExternalAccountType' } & Pick<Types.ExternalAccountType, 'type' | 'supportCreateAccount'>
  >;
};

export const ListExternalAccountTypesDocument = /*#__PURE__*/ gql`
    query listExternalAccountTypes {
  listExternalAccountTypes {
    type
    supportCreateAccount
  }
}
    `;

/**
 * __useListExternalAccountTypesQuery__
 *
 * To run a query within a React component, call `useListExternalAccountTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExternalAccountTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExternalAccountTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListExternalAccountTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>(
    ListExternalAccountTypesDocument,
    options,
  );
}
export function useListExternalAccountTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>(
    ListExternalAccountTypesDocument,
    options,
  );
}
// @ts-expect-error
export function useListExternalAccountTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>;
export function useListExternalAccountTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListExternalAccountTypesQuery | undefined, ListExternalAccountTypesQueryVariables>;
export function useListExternalAccountTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListExternalAccountTypesQuery, ListExternalAccountTypesQueryVariables>(
    ListExternalAccountTypesDocument,
    options,
  );
}
export type ListExternalAccountTypesQueryHookResult = ReturnType<typeof useListExternalAccountTypesQuery>;
export type ListExternalAccountTypesLazyQueryHookResult = ReturnType<typeof useListExternalAccountTypesLazyQuery>;
export type ListExternalAccountTypesSuspenseQueryHookResult = ReturnType<
  typeof useListExternalAccountTypesSuspenseQuery
>;
